import React, { useState, useEffect } from 'react';
import './LoadingBar.css';

export default function LoadingBar({ text }) {
    const [loading, setLoading] = useState(true);

    if (loading) {
        return (
            <div className="loading-bar-container" dir="RTL">
                <div className="loading-bar">
                    <div className="loading-bar-fill"></div>
                </div>
                <p className="loading-text">טוען {text}...</p>
            </div>
        );
    }

    return null;
}
